import { useQuery } from "@tanstack/react-query";
import { listContacts } from "../lib/api-client";
import { mailboxQueryKeys } from "../lib/query-keys";

/**
 * Recipient autocomplete suggestions, derived from this mailbox's real
 * correspondence history (see apps/mail's db/do/schema.sql `contacts` table
 * docstring — NOT a manually-managed address book). Unlike useSearch, this
 * is meant to fire even with a blank `q` (the server returns top recent/
 * frequent contacts for an empty query) — that's what lets
 * RecipientInput show useful suggestions the instant a field is focused,
 * before any typing. `enabled` lets the caller gate the query on "the
 * dropdown is actually open" so focusing-then-immediately-blurring a field
 * doesn't fire a request. `q` is expected already debounced by the caller
 * (see components/mail/recipient-input.tsx).
 */
export function useContacts(mailboxId: string | undefined, q: string, opts: { enabled?: boolean } = {}) {
  const trimmed = q.trim();
  return useQuery({
    queryKey: mailboxQueryKeys.contacts(mailboxId ?? "", trimmed),
    queryFn: () => listContacts(mailboxId!, trimmed),
    enabled: Boolean(mailboxId) && (opts.enabled ?? true),
    staleTime: 15_000,
  });
}
